(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (window.WrydecoCartDrawerInitialized) return;
    window.WrydecoCartDrawerInitialized = true;

    let lastFocusedElement = null;
    let updateController = null;

    const getShell = () => document.querySelector('[data-cart-drawer-shell]');
    const getPanel = () => getShell()?.querySelector('[data-cart-drawer-panel]');
    const floatingWidgetSelectors = [
      '#shopify-chat',
      '#ShopifyChat',
      '#chat-widget-container',
      '.shopify-chat',
      '.shopify-chat-launcher',
      '.intercom-lightweight-app',
      '.crisp-client',
      '[id*="chat" i]',
      '[class*="chat" i]',
      '[id*="inbox" i]',
      '[class*="inbox" i]',
      '[id*="sidekick" i]',
      '[class*="sidekick" i]',
      'iframe[title*="chat" i]',
      'iframe[id*="chat" i]',
      'iframe[src*="chat" i]',
      'iframe[src*="inbox" i]',
      'iframe[src*="sidekick" i]',
    ];

    const shouldHideFloatingWidget = (element) => {
      if (!(element instanceof HTMLElement)) return false;
      if (element.closest('[data-cart-drawer-shell], .cart-drawer__note-popup, #global-toast-container')) return false;

      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;

      const rect = element.getBoundingClientRect();
      const isBottomRightFloating =
        style.position === 'fixed' &&
        rect.width > 0 &&
        rect.height > 0 &&
        rect.right > window.innerWidth - 180 &&
        rect.bottom > window.innerHeight - 260;

      return isBottomRightFloating;
    };

    const hideCartDrawerFloatingWidgets = () => {
      const candidates = new Set();

      floatingWidgetSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => candidates.add(element));
      });

      Array.from(document.body.children).forEach((element) => {
        if (shouldHideFloatingWidget(element)) candidates.add(element);
      });

      candidates.forEach((element) => {
        if (!(element instanceof HTMLElement)) return;
        if (element.dataset.cartDrawerHiddenFloating === 'true') return;
        if (!shouldHideFloatingWidget(element) && !element.matches(floatingWidgetSelectors.join(','))) return;

        element.dataset.cartDrawerPreviousStyle = element.getAttribute('style') || '';
        element.dataset.cartDrawerHiddenFloating = 'true';
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('opacity', '0', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });
    };

    const restoreCartDrawerFloatingWidgets = () => {
      document.querySelectorAll('[data-cart-drawer-hidden-floating="true"]').forEach((element) => {
        const previousStyle = element.dataset.cartDrawerPreviousStyle || '';
        if (previousStyle) {
          element.setAttribute('style', previousStyle);
        } else {
          element.removeAttribute('style');
        }

        delete element.dataset.cartDrawerPreviousStyle;
        delete element.dataset.cartDrawerHiddenFloating;
      });
    };

    const updateCartBubble = (count) => {
      document.querySelectorAll('.header__icon--cart').forEach((cartIcon) => {
        let bubble = cartIcon.querySelector('.cart-count-bubble');
        if (count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span></span>';
            cartIcon.appendChild(bubble);
          }
          bubble.querySelector('span').textContent = count;
        } else if (bubble) {
          bubble.remove();
        }
      });
    };

    const openDrawer = () => {
      const shell = getShell();
      const panel = getPanel();
      if (!shell || !panel) return;
      lastFocusedElement = document.activeElement;
      shell.classList.add('is-open');
      shell.setAttribute('aria-hidden', 'false');
      shell.removeAttribute('inert');
      document.documentElement.classList.add('cart-drawer-is-open');
      document.body.classList.add('cart-drawer-is-open');
      hideCartDrawerFloatingWidgets();
      syncPendingDiscount();
      window.requestAnimationFrame(() => panel.focus());
    };

    const closeDrawer = () => {
      const shell = getShell();
      if (!shell) return;
      shell.classList.remove('is-open');
      shell.setAttribute('aria-hidden', 'true');
      shell.setAttribute('inert', '');
      document.documentElement.classList.remove('cart-drawer-is-open');
      document.body.classList.remove('cart-drawer-is-open');
      restoreCartDrawerFloatingWidgets();
      if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
    };

    const refreshDrawer = async ({ open = false } = {}) => {
      const shell = getShell();
      if (!shell) return;
      const sectionId = shell.dataset.sectionId || 'cart-drawer';
      const root = window.Shopify?.routes?.root || '/';
      const separator = root.includes('?') ? '&' : '?';
      const response = await fetch(`${root}${separator}section_id=${encodeURIComponent(sectionId)}`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Unable to refresh your cart.');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-cart-drawer-shell]');
      if (!replacement) throw new Error('Unable to refresh your cart.');
      const wasOpen = shell.classList.contains('is-open') || open;
      shell.replaceWith(replacement);
      if (wasOpen) openDrawer();
      // Read the exact item count from a clean numeric attribute — the visible
      // "(N pieces added" text starts with "(", so parseInt on it returned NaN
      // and wiped the header badge.
      const count = Number.parseInt(replacement.dataset.cartCount, 10);
      updateCartBubble(Number.isNaN(count) ? 0 : count);
      syncPendingDiscount();
    };

    const changeLine = async (lineItem, quantity) => {
      const shell = getShell();
      const loader = shell?.querySelector('[data-cart-drawer-loading]');
      const lineKey = lineItem?.dataset.lineKey;
      if (!lineKey || !loader) return;
      if (updateController) updateController.abort();
      updateController = new AbortController();
      loader.hidden = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity }),
          signal: updateController.signal,
        });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || 'Unable to update your cart.');
        updateCartBubble(cart.item_count);
        await refreshDrawer({ open: true });
        document.dispatchEvent(new CustomEvent('wry:cart-changed'));
      } catch (error) {
        if (error.name === 'AbortError') return;
        loader.hidden = true;
        if (window.showToast) {
          window.showToast({ message: error.message, type: 'error', position: 'bottom-left' });
        }
      }
    };

    // Persist the entered code so it is applied at checkout even when the in-cart
    // /discount endpoint can't confirm it (e.g. the Shopify theme dev preview
    // blocks /discount and /checkout with a 401 — they only work on the live store).
    const CHECKOUT_DISCOUNT_KEY = 'wrydeco:pending-discount';
    const rememberCheckoutDiscount = (code) => {
      try {
        window.sessionStorage.setItem(CHECKOUT_DISCOUNT_KEY, code);
      } catch (error) {
        /* sessionStorage unavailable — checkout carry simply won't persist */
      }
    };
    const forgetCheckoutDiscount = () => {
      try {
        window.sessionStorage.removeItem(CHECKOUT_DISCOUNT_KEY);
      } catch (error) {
        /* no-op */
      }
    };
    const getCheckoutDiscount = () => {
      try {
        return window.sessionStorage.getItem(CHECKOUT_DISCOUNT_KEY);
      } catch (error) {
        return null;
      }
    };

    const getDiscountPopup = () => document.querySelector('[data-cart-discount-popup]');
    let discountPopupCloseHandler;
    let discountPopupTrigger;
    const openDiscountPopup = (trigger) => {
      const popup = getDiscountPopup();
      if (!popup) return;
      if (discountPopupCloseHandler) {
        popup.removeEventListener('transitionend', discountPopupCloseHandler);
        discountPopupCloseHandler = null;
      }
      discountPopupTrigger = trigger || document.activeElement;
      popup.hidden = false;
      popup.dataset.open = 'true';
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(() => {
        if (popup.dataset.open !== 'true') return;
        popup.classList.add('is-open');
        popup.querySelector('[data-cart-discount-input]')?.focus();
      });
    };
    const closeDiscountPopup = () => {
      const popup = getDiscountPopup();
      if (!popup || popup.hidden || popup.dataset.open !== 'true') return;
      popup.dataset.open = 'false';
      popup.classList.remove('is-open');
      document.documentElement.style.overflow = '';

      const finishClose = (event) => {
        if (event && event.target !== popup) return;
        popup.removeEventListener('transitionend', finishClose);
        discountPopupCloseHandler = null;
        if (popup.dataset.open === 'true') return;
        popup.hidden = true;
        discountPopupTrigger?.focus();
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finishClose();
        return;
      }

      discountPopupCloseHandler = finishClose;
      popup.addEventListener('transitionend', finishClose);
    };

    const applyDiscount = async (form) => {
      const input = form.querySelector('[data-cart-discount-input]');
      const code = (input?.value || '').trim();
      if (!code) {
        input?.focus();
        return;
      }
      const popup = getDiscountPopup();
      const popupLoader = popup?.querySelector('[data-cart-discount-loading]');
      const applyBtn = form.querySelector('[data-cart-discount-apply]');
      const root = window.Shopify?.routes?.root || '/';
      const toast = (options) => {
        if (window.showToast) window.showToast(Object.assign({ position: 'bottom-left' }, options));
      };

      // The spinner shows inside the popup (not the cart drawer) while we validate.
      if (popupLoader) popupLoader.hidden = false;
      if (applyBtn) applyBtn.disabled = true;

      try {
        // POST /cart/update.js with a discount applies the code to the cart session on
        // BOTH the live store and the theme dev preview — unlike /discount/CODE, which the
        // preview blocks with 401. The returned cart reports each code's `applicable`
        // flag, so we can give a definitive success/fail result (no vague "at checkout").
        const res = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        const cart = res.ok ? await res.json() : null;
        const entry = cart
          ? (cart.discount_codes || []).find((discount) => (discount.code || '').toLowerCase() === code.toLowerCase())
          : null;
        // `applicable` is Shopify's validity signal in the update response. We don't read
        // `total_discount` here — the cart/update.js body doesn't populate it yet; the
        // real reduced totals come from refreshDrawer's server-rendered cart below.
        const applied = !!entry && entry.applicable === true;

        if (applied) {
          // Really applied and reducing the cart — re-render the drawer so the discount
          // row and the reduced subtotal show immediately.
          await refreshDrawer({ open: true });
          closeDiscountPopup();
          toast({ message: `Discount “${code}” applied.`, type: 'success' });
        } else {
          // Invalid or not applicable — drop the code so it doesn't linger on the cart,
          // then report a clear failure.
          await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' }),
          });
          if (input) {
            input.focus();
            input.select();
          }
          toast({ message: `“${code}” isn’t a valid discount code.`, type: 'error' });
        }
      } catch (error) {
        toast({ message: 'We couldn’t apply that code. Please try again.', type: 'error' });
      } finally {
        if (popupLoader) popupLoader.hidden = true;
        if (applyBtn) applyBtn.disabled = false;
      }
    };

    const escapeHtml = (value) =>
      String(value).replace(
        /[&<>"']/g,
        (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char])
      );

    // Renders a "pending" discount chip from the code carried to checkout, but only
    // when no discount is actually applied in-cart (e.g. theme dev preview). This
    // gives the shopper a way to cancel a code they entered but that hasn't reduced
    // the cart yet. Applied discounts are rendered server-side by Liquid instead.
    const syncPendingDiscount = () => {
      const shell = getShell();
      const container = shell?.querySelector('[data-cart-pending-discount]');
      if (!container) return;
      const code = getCheckoutDiscount();
      const hasApplied = !!shell.querySelector(
        '.cart-drawer__summary-row--discount:not(.cart-drawer__pending-discount)'
      );
      if (code && !hasApplied) {
        container.hidden = false;
        container.innerHTML =
          '<span class="cart-drawer__discount-tag">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 12.5 12 21l-8.5-8.5V4h8.5z"></path><circle cx="8" cy="8" r="1.4"></circle></svg>' +
          escapeHtml(code) +
          '</span>' +
          '<span class="cart-drawer__discount-end">' +
          '<span class="cart-drawer__pending-note">At checkout</span>' +
          '<button type="button" class="cart-drawer__discount-remove" data-cart-pending-remove aria-label="Remove discount ' +
          escapeHtml(code) +
          '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg></button>' +
          '</span>';
      } else {
        container.hidden = true;
        container.innerHTML = '';
      }
    };

    // Removing a discount clears the cart's discount codes via the Cart AJAX API
    // (POST /cart/update.js with an empty `discount`) — this works on both the live
    // store and the theme dev preview — and also drops the code carried to checkout.
    const removeDiscount = async () => {
      const shell = getShell();
      const loader = shell?.querySelector('[data-cart-drawer-loading]');
      if (!loader) return;
      loader.hidden = false;
      const root = window.Shopify?.routes?.root || '/';
      try {
        await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '' }),
        });
        forgetCheckoutDiscount();
        await refreshDrawer({ open: true });
        if (window.showToast) {
          window.showToast({ message: 'Discount removed.', type: 'info', position: 'bottom-left' });
        }
      } catch (error) {
        loader.hidden = true;
        if (window.showToast) {
          window.showToast({
            message: 'We couldn’t remove the discount. Please try again.',
            type: 'error',
            position: 'bottom-left',
          });
        }
      }
    };

    // Checkout leaves the storefront entirely, so the button keeps its busy state
    // until the browser paints the checkout page. `disabled` is deliberately not
    // used — it would drop the submit button's name from the posted form data —
    // so a flag plus `pointer-events: none` guards against a double submit.
    let checkoutSubmitting = false;
    const setCheckoutBusy = (button, busy) => {
      if (!button) return;
      checkoutSubmitting = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    };
    const resetCheckoutButtons = () => {
      checkoutSubmitting = false;
      document.querySelectorAll('[data-cart-checkout]').forEach((button) => {
        button.setAttribute('aria-busy', 'false');
      });
    };

    document.addEventListener('submit', (event) => {
      const discountForm = event.target.closest('[data-cart-discount-form]');
      if (discountForm) {
        event.preventDefault();
        applyDiscount(discountForm);
        return;
      }

      // Carry any entered discount code through to checkout so it applies there.
      const checkoutForm = event.target.closest('.cart-drawer__checkout-form');
      if (checkoutForm) {
        if (checkoutSubmitting) {
          event.preventDefault();
          return;
        }
        setCheckoutBusy(checkoutForm.querySelector('[data-cart-checkout]'), true);

        const pending = getCheckoutDiscount();
        if (pending) {
          event.preventDefault();
          const root = window.Shopify?.routes?.root || '/';
          window.location.href = `${root}checkout?discount=${encodeURIComponent(pending)}`;
        }
      }
    });

    // Coming back from checkout via the back button restores the page from the
    // bfcache with the DOM untouched, so clear the spinner explicitly.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) resetCheckoutButtons();
    });

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const discountPopupOpener = event.target.closest('[data-cart-discount-open]');
      if (discountPopupOpener) {
        event.preventDefault();
        openDiscountPopup(discountPopupOpener);
        return;
      }

      if (event.target.closest('[data-cart-discount-close]')) {
        event.preventDefault();
        closeDiscountPopup();
        return;
      }

      if (event.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }

      if (event.target.closest('[data-cart-discount-remove]')) {
        removeDiscount();
        return;
      }

      if (event.target.closest('[data-cart-pending-remove]')) {
        forgetCheckoutDiscount();
        syncPendingDiscount();
        if (window.showToast) {
          window.showToast({ message: 'Discount removed.', type: 'info', position: 'bottom-left' });
        }
        return;
      }

      const quantityButton = event.target.closest('[data-cart-quantity-change]');
      if (quantityButton) {
        const lineItem = quantityButton.closest('[data-cart-line-item]');
        changeLine(lineItem, Number(quantityButton.dataset.cartQuantityChange));
        return;
      }

      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        const lineItem = removeButton.closest('[data-cart-line-item]');
        const popup = document.querySelector('[data-cart-remove-popup]');
        if (popup && lineItem) {
          popup.dataset.lineKey = lineItem.dataset.lineKey;
          popup.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        } else if (lineItem) {
          changeLine(lineItem, 0);
        }
        return;
      }

      const removeCancelBtn = event.target.closest('[data-cart-remove-cancel]');
      if (removeCancelBtn) {
        const popup = document.querySelector('[data-cart-remove-popup]');
        if (popup) {
          popup.hidden = true;
          document.documentElement.style.overflow = '';
        }
        return;
      }

      const removeConfirmBtn = event.target.closest('[data-cart-remove-confirm]');
      if (removeConfirmBtn) {
        const popup = document.querySelector('[data-cart-remove-popup]');
        if (popup && popup.dataset.lineKey) {
          changeLine({ dataset: { lineKey: popup.dataset.lineKey } }, 0);
          popup.hidden = true;
          document.documentElement.style.overflow = '';
        }
        return;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const discountPopup = getDiscountPopup();
        if (discountPopup && !discountPopup.hidden) {
          closeDiscountPopup();
          return;
        }
        const removePopup = document.querySelector('[data-cart-remove-popup]');
        if (removePopup && !removePopup.hidden) {
          removePopup.hidden = true;
          document.documentElement.style.overflow = '';
          return;
        }
      }
      const shell = getShell();
      if (!shell?.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [
        ...getPanel().querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ),
      ];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('cart:updated', (event) => {
      refreshDrawer({ open: event.detail?.open !== false }).catch((error) => {
        if (window.showToast) {
          window.showToast({ message: error.message, type: 'error', position: 'bottom-left' });
        }
      });
    });

    window.WrydecoCartDrawer = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sectionRoot = document.querySelector('[data-client-reviews]');
    if (!sectionRoot) return;

    const carousel = sectionRoot.querySelector('[data-client-reviews-carousel]');
    const slider = sectionRoot.querySelector('[data-client-reviews-slider]');
    if (!slider) return;

    const cards = Array.from(slider.querySelectorAll('.client-reviews__card'));
    const prev = carousel ? carousel.querySelector('[data-client-reviews-prev]') : null;
    const next = carousel ? carousel.querySelector('[data-client-reviews-next]') : null;
    const textEl = sectionRoot.querySelector('[data-client-review-text]');
    const authorEl = sectionRoot.querySelector('[data-client-review-author]');
    const locationEl = sectionRoot.querySelector('[data-client-review-location]');

    let currentCommentCard = null;
    let textUpdateTimer = null;

    function updateText(card) {
      if (!card || card === currentCommentCard) return;
      currentCommentCard = card;
      window.clearTimeout(textUpdateTimer);

      // Slight fade effect
      textEl.style.opacity = '0';
      authorEl.style.opacity = '0';

      textUpdateTimer = window.setTimeout(() => {
        textEl.textContent = card.dataset.review;
        authorEl.textContent = card.dataset.author;
        if (locationEl) locationEl.textContent = card.dataset.location || '';
        textEl.style.opacity = '1';
        authorEl.style.opacity = '1';
      }, 150);
    }

    function cardStep() {
      const card = cards[0];
      if (!card) return slider.clientWidth;

      const styles = getComputedStyle(slider);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function updateTrailingSpace() {
      if (cards.length === 0) return;

      cards.forEach((card) => {
        card.style.marginRight = '';
      });

      const lastCard = cards[cards.length - 1];
      const extraSpace = slider.clientWidth - lastCard.getBoundingClientRect().width;
      if (extraSpace > 0) {
        lastCard.style.marginRight = `${extraSpace}px`;
      }
    }

    function firstCardInViewport() {
      if (cards.length === 0) return;

      const sliderRect = slider.getBoundingClientRect();
      const sliderLeft = sliderRect.left;

      let closestCard = cards[0];
      let minDistance = Infinity;

      cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const distance = Math.abs(sliderLeft - cardRect.left);

        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      return closestCard;
    }

    function updateCommentFromViewport() {
      const sourceCard = firstCardInViewport();
      const sourceIndex = cards.indexOf(sourceCard);

      cards.forEach((card) => {
        card.classList.remove('is-comment-source', 'is-comment-preview');
      });

      if (sourceCard) {
        sourceCard.classList.add('is-comment-source');
      }

      if (sourceIndex >= 0 && cards[sourceIndex + 1]) {
        cards[sourceIndex + 1].classList.add('is-comment-preview');
      }

      updateText(sourceCard);
    }

    function updateNav() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const hasOverflow = maxScroll > 1;
      if (prev) prev.disabled = !hasOverflow || slider.scrollLeft <= 1;
      if (next) next.disabled = !hasOverflow || slider.scrollLeft >= maxScroll - 1;
    }

    function scrollByCard(direction) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slider.scrollBy({
        left: cardStep() * direction,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    // Initial check
    updateTrailingSpace();
    updateCommentFromViewport();
    updateNav();

    if (prev) {
      prev.addEventListener('click', () => {
        scrollByCard(-1);
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        scrollByCard(1);
      });
    }

    // Listen for scroll events on the slider to update the comment from the
    // first card in the viewport.
    let ticking = false;
    slider.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateCommentFromViewport();
            updateNav();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    // Also update on window resize since layout might change
    window.addEventListener('resize', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateTrailingSpace();
          updateCommentFromViewport();
          updateNav();
          ticking = false;
        });
        ticking = true;
      }
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        updateTrailingSpace();
        updateCommentFromViewport();
        updateNav();
      });
      resizeObserver.observe(slider);
    }

    // Press-and-drag to scroll (mouse). Matches the PDP "You May Also Like"
    // carousel: threshold protects simple clicks, real drags suppress click.
    let isDown = false;
    let startX = 0;
    let isDragging = false;
    let dragDirection = 0;
    const THRESHOLD = 5;

    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      dragDirection = 0;
      startX = e.pageX - slider.offsetLeft;
    });

    function endDrag() {
      const shouldScroll = isDragging && dragDirection !== 0;
      isDown = false;
      slider.classList.remove('is-dragging');
      if (shouldScroll) {
        scrollByCard(dragDirection);
      }
      updateNav();
    }

    slider.addEventListener('mouseleave', endDrag);
    slider.addEventListener('mouseup', endDrag);

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - slider.offsetLeft;
      const distance = x - startX;
      if (!isDragging && Math.abs(distance) > THRESHOLD) {
        isDragging = true;
        slider.classList.add('is-dragging');
      }
      if (!isDragging) return;

      e.preventDefault();
      dragDirection = distance < 0 ? 1 : -1;
    });

    slider.addEventListener(
      'click',
      (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.curated-collections__grid');
    sliders.forEach((slider) => {
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('is-dragging');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });

      let isDragging = false;
      slider.addEventListener('mousemove', (e) => {
        if (isDown) isDragging = true;
      });
      slider.addEventListener('mousedown', () => {
        isDragging = false;
      });
      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customization-consultation"] && !Shopify.designMode) return;
  try {
    
  const initializeCustomizationInquiry = () => {
    const notify = (message, type) => {
      if (window.showToast) {
        window.showToast({ message, type, position: 'bottom-left', duration: 4000 });
      }
    };

    document.querySelectorAll('.custom-inquiry__form:not([data-schedule-initialized])').forEach((form) => {
      form.dataset.scheduleInitialized = 'true';

      const popup = form.querySelector('[data-schedule-popup]');
      const dialog = popup?.querySelector('.consultation-scheduler__dialog');
      const openButton = form.querySelector('[data-schedule-open]');
      const confirmButton = form.querySelector('[data-schedule-confirm]');
      const hiddenInput = form.querySelector('[data-schedule-value]');
      const currentSummary = form.querySelector('[data-schedule-current]');
      const currentValue = form.querySelector('[data-schedule-current-value]');
      const scheduleButtonLabel = form.querySelector('[data-schedule-button-label]');
      const scheduleDefaultIcon = form.querySelector('[data-schedule-default-icon]');
      const scheduleCompleteIcon = form.querySelector('[data-schedule-complete-icon]');
      const result = form.querySelector('[data-schedule-result]');
      const monthLabel = form.querySelector('[data-calendar-month]');
      const daysGrid = form.querySelector('[data-calendar-days]');
      const prevButton = form.querySelector('[data-calendar-prev]');
      const nextButton = form.querySelector('[data-calendar-next]');
      const slotsContainer = form.querySelector('[data-schedule-slots]');

      if (!popup || !dialog || !openButton || !confirmButton || !hiddenInput) return;

      const defaultScheduleLabel = scheduleButtonLabel?.textContent || 'Schedule an online consultation';
      const completedScheduleLabel = openButton.dataset.scheduledLabel || 'CONSULTATION SCHEDULED';

      const pad = (value) => String(value).padStart(2, '0');

      // Fixed US business-hours slots, 09:00 AM – 05:00 PM in 30-minute steps.
      const SLOT_START_MINUTES = 9 * 60; // 09:00
      const SLOT_END_MINUTES = 16 * 60; // 16:00 (04:00 PM), inclusive — last bookable slot
      const SLOT_STEP_MINUTES = 30;
      const timeSlots = [];
      for (let minutes = SLOT_START_MINUTES; minutes <= SLOT_END_MINUTES; minutes += SLOT_STEP_MINUTES) {
        const hour24 = Math.floor(minutes / 60);
        const minute = minutes % 60;
        const period = hour24 >= 12 ? 'PM' : 'AM';
        let hour12 = hour24 % 12;
        if (hour12 === 0) hour12 = 12;
        timeSlots.push({
          hour: hour12,
          minute,
          period,
          startMinutes: minutes,
          label: `${pad(hour12)}:${pad(minute)} ${period}`,
        });
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const firstMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastMonth = new Date(today.getFullYear(), today.getMonth() + 2, 1);
      let visibleMonth = new Date(firstMonth);
      let selectedDate = null;
      let selectedHour = null;
      let selectedMinute = null;
      let selectedPeriod = null;
      let returnFocus = null;
      let committedSelection = null;

      // A consultation must be booked at least 24h ahead. The threshold is based
      // on the real current time (not midnight), so both the date column and the
      // individual time slots are validated against the same moment.
      const MIN_LEAD_MS = 24 * 60 * 60 * 1000;
      const getMinMoment = () => new Date(Date.now() + MIN_LEAD_MS);

      const slotDateTime = (date, slot) => {
        if (!date || !slot) return null;
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          Math.floor(slot.startMinutes / 60),
          slot.startMinutes % 60,
          0,
          0
        );
      };

      const findSelectedSlot = () =>
        timeSlots.find(
          (slot) => slot.hour === selectedHour && slot.minute === selectedMinute && slot.period === selectedPeriod
        );

      // If the picked time is now within the 24h window (e.g. after switching to a
      // boundary date), drop it so the shopper must choose a still-valid slot.
      const pruneInvalidTime = () => {
        const slot = findSelectedSlot();
        if (!selectedDate || !slot) return;
        if (slotDateTime(selectedDate, slot).getTime() < getMinMoment().getTime()) {
          selectedHour = null;
          selectedMinute = null;
          selectedPeriod = null;
        }
      };

      const sameDay = (left, right) =>
        left &&
        right &&
        left.getFullYear() === right.getFullYear() &&
        left.getMonth() === right.getMonth() &&
        left.getDate() === right.getDate();

      const formatSelection = () => {
        if (!selectedDate || selectedHour == null || selectedMinute == null) return '';
        return `${pad(selectedHour)}:${pad(selectedMinute)} ${selectedPeriod}, ${pad(selectedDate.getDate())}/${pad(
          selectedDate.getMonth() + 1
        )}/${selectedDate.getFullYear()}`;
      };

      const syncSelection = () => {
        const formatted = formatSelection();
        let bookable = Boolean(formatted);
        if (bookable) {
          const slot = findSelectedSlot();
          if (slot && slotDateTime(selectedDate, slot).getTime() < getMinMoment().getTime()) {
            bookable = false;
          }
        }
        if (result) result.textContent = formatted || 'Choose a date and time to continue.';
        confirmButton.disabled = !bookable;
      };

      const renderCalendar = () => {
        if (!daysGrid || !monthLabel) return;
        monthLabel.textContent = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(
          visibleMonth
        );
        daysGrid.textContent = '';

        const year = visibleMonth.getFullYear();
        const month = visibleMonth.getMonth();
        const firstWeekday = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let index = 0; index < firstWeekday; index += 1) {
          const blank = document.createElement('span');
          blank.className = 'consultation-calendar__day--blank';
          blank.setAttribute('aria-hidden', 'true');
          daysGrid.append(blank);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const date = new Date(year, month, day);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'consultation-calendar__day';
          button.textContent = day;
          // The day is bookable only if its last slot still clears the 24h window.
          const lastSlotDateTime = slotDateTime(date, timeSlots[timeSlots.length - 1]);
          button.disabled = lastSlotDateTime.getTime() < getMinMoment().getTime();
          button.setAttribute(
            'aria-label',
            new Intl.DateTimeFormat('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            }).format(date)
          );
          if (sameDay(date, selectedDate)) {
            button.classList.add('is-selected');
            button.setAttribute('aria-pressed', 'true');
          } else {
            button.setAttribute('aria-pressed', 'false');
          }
          button.addEventListener('click', () => {
            selectedDate = date;
            pruneInvalidTime();
            renderCalendar();
            renderSlots();
            syncSelection();
          });
          daysGrid.append(button);
        }

        if (prevButton) prevButton.disabled = visibleMonth.getTime() <= firstMonth.getTime();
        if (nextButton) nextButton.disabled = visibleMonth.getTime() >= lastMonth.getTime();
      };

      const renderSlots = () => {
        if (!slotsContainer) return;
        slotsContainer.textContent = '';

        const minMoment = getMinMoment();

        timeSlots.forEach((slot) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'consultation-slots__slot';
          button.textContent = slot.label;
          // Once a date is chosen, slots inside the 24h window are not bookable.
          const slotTime = slotDateTime(selectedDate, slot);
          const isTooSoon = Boolean(selectedDate) && slotTime.getTime() < minMoment.getTime();
          button.disabled = isTooSoon;
          const isSelected =
            !isTooSoon &&
            selectedHour === slot.hour &&
            selectedMinute === slot.minute &&
            selectedPeriod === slot.period;
          if (isSelected) button.classList.add('is-selected');
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          button.setAttribute('aria-label', `${slot.label} consultation slot`);
          button.addEventListener('click', () => {
            selectedHour = slot.hour;
            selectedMinute = slot.minute;
            selectedPeriod = slot.period;
            renderSlots();
            syncSelection();
          });
          slotsContainer.append(button);
        });
      };

      const restoreCommittedSelection = () => {
        selectedDate = committedSelection?.date ? new Date(committedSelection.date) : null;
        selectedHour = committedSelection?.hour ?? null;
        selectedMinute = committedSelection?.minute ?? null;
        selectedPeriod = committedSelection?.period ?? null;
        renderCalendar();
        renderSlots();
        syncSelection();
      };

      const closePopup = (discardChanges = false) => {
        if (popup.hidden) return;
        if (discardChanges) restoreCommittedSelection();
        popup.classList.remove('is-open');
        document.documentElement.classList.remove('consultation-scheduler-open');
        openButton.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKeydown);
        window.setTimeout(() => {
          popup.hidden = true;
          returnFocus?.focus();
        }, 250);
      };

      const onKeydown = (event) => {
        if (event.key === 'Escape') {
          closePopup(true);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(
          dialog.querySelectorAll(
            'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      const openPopup = () => {
        returnFocus = document.activeElement;
        popup.hidden = false;
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('consultation-scheduler-open');
        renderCalendar();
        renderSlots();
        syncSelection();
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => popup.classList.add('is-open')));
        document.addEventListener('keydown', onKeydown);
        dialog.focus();
      };

      prevButton?.addEventListener('click', () => {
        if (visibleMonth.getTime() <= firstMonth.getTime()) return;
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1);
        renderCalendar();
      });
      nextButton?.addEventListener('click', () => {
        if (visibleMonth.getTime() >= lastMonth.getTime()) return;
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1);
        renderCalendar();
      });
      openButton.addEventListener('click', openPopup);
      popup
        .querySelectorAll('[data-schedule-close]')
        .forEach((button) => button.addEventListener('click', () => closePopup(true)));
      confirmButton.addEventListener('click', () => {
        const formatted = formatSelection();
        if (!formatted) return;
        committedSelection = {
          date: selectedDate.getTime(),
          hour: selectedHour,
          minute: selectedMinute,
          period: selectedPeriod,
        };
        hiddenInput.value = formatted;
        if (currentValue) currentValue.textContent = formatted;
        if (currentSummary) currentSummary.hidden = false;
        if (scheduleButtonLabel) scheduleButtonLabel.textContent = completedScheduleLabel;
        if (scheduleDefaultIcon) scheduleDefaultIcon.hidden = true;
        if (scheduleCompleteIcon) scheduleCompleteIcon.hidden = false;
        openButton.classList.add('is-scheduled');
        closePopup();
      });
      form.addEventListener('consultation:schedule-reset', () => {
        selectedDate = null;
        selectedHour = null;
        selectedMinute = null;
        selectedPeriod = null;
        committedSelection = null;
        visibleMonth = new Date(firstMonth);
        hiddenInput.value = '';
        if (currentValue) currentValue.textContent = '';
        if (currentSummary) currentSummary.hidden = true;
        if (scheduleButtonLabel) scheduleButtonLabel.textContent = defaultScheduleLabel;
        if (scheduleDefaultIcon) scheduleDefaultIcon.hidden = false;
        if (scheduleCompleteIcon) scheduleCompleteIcon.hidden = true;
        openButton.classList.remove('is-scheduled');
        renderCalendar();
        renderSlots();
        syncSelection();
      });

      renderCalendar();
      renderSlots();
      syncSelection();
    });

    document.querySelectorAll('.custom-inquiry__form:not([data-submit-initialized])').forEach((form) => {
      form.dataset.submitInitialized = 'true';

      const section = form.closest('.custom-inquiry');
      const endpoint = section?.dataset.consultationEndpoint;
      if (!endpoint) return;

      const successMessage = section.dataset.successMessage || 'Thank you. Your consultation request has been sent.';
      const errorMessage = section.dataset.errorMessage || 'Something went wrong. Please try again.';

      // Inline, per-field error handling. `errorEls` are keyed by the API's field
      // names (name / phone_or_email / message) so the API's own validation errors
      // can be mapped straight back onto the right input.
      const fields = {
        name: form.querySelector('[name="name"]'),
        phone_or_email: form.querySelector('[name="phone_or_email"]'),
        message: form.querySelector('[name="message"]'),
      };
      const errorEls = {
        name: form.querySelector('[data-field-error="name"]'),
        phone_or_email: form.querySelector('[data-field-error="phone_or_email"]'),
        message: form.querySelector('[data-field-error="message"]'),
      };

      const setFieldError = (fieldName, message) => {
        const input = fields[fieldName];
        const el = errorEls[fieldName];
        if (input) input.setAttribute('aria-invalid', 'true');
        if (el) {
          el.textContent = message;
          el.hidden = false;
        }
      };
      const clearFieldError = (fieldName) => {
        const input = fields[fieldName];
        const el = errorEls[fieldName];
        if (input) input.removeAttribute('aria-invalid');
        if (el) {
          el.textContent = '';
          el.hidden = true;
        }
      };
      const clearAllErrors = () => Object.keys(errorEls).forEach(clearFieldError);

      // Clear a field's error the moment the shopper starts fixing it.
      Object.entries(fields).forEach(([fieldName, input]) => {
        input?.addEventListener('input', () => clearFieldError(fieldName));
      });

      const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidContact = (value) => {
        if (EMAIL_RE.test(value)) return true;
        // Phone: 7–15 digits and only phone-ish characters.
        const digits = value.replace(/\D/g, '');
        return digits.length >= 7 && digits.length <= 15 && /^[+()\d\s.-]+$/.test(value);
      };

      // Client-side validation that mirrors the API's rules, so obvious mistakes
      // are caught before the request goes out (form is novalidate).
      const validateForm = () => {
        clearAllErrors();
        let firstInvalid = null;
        const fail = (fieldName, message) => {
          setFieldError(fieldName, message);
          if (!firstInvalid) firstInvalid = fields[fieldName];
        };

        const name = fields.name?.value.trim() || '';
        const contact = fields.phone_or_email?.value.trim() || '';
        const message = fields.message?.value.trim() || '';

        if (!name) fail('name', 'Name is required.');
        if (!contact) fail('phone_or_email', 'A phone number or email address is required.');
        else if (!isValidContact(contact)) fail('phone_or_email', 'Enter a valid phone number or email address.');
        if (!message) fail('message', 'A short request is required.');
        else if (message.length < 10) fail('message', 'Message must be at least 10 characters.');
        else if (message.length > 10000) fail('message', 'Message must be at most 10,000 characters.');

        if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();
        return !firstInvalid;
      };

      form.addEventListener('submit', async (event) => {
        // Fully AJAX: never let the browser navigate/reload.
        event.preventDefault();

        // Validate in JS (form is novalidate) and show inline field errors.
        if (!validateForm()) return;

        const submitButton = form.querySelector('.custom-inquiry__submit');
        const labelSpan = submitButton?.querySelector('span:first-child');
        const originalLabel = labelSpan?.textContent;

        const getValue = (name) => form.querySelector(`[name="${name}"]`)?.value.trim() || '';

        const formData = new FormData();
        formData.append('name', getValue('name'));
        formData.append('phone_or_email', getValue('phone_or_email'));
        formData.append('message', getValue('message'));
        formData.append('consultation_time', getValue('consultation_time'));

        const fileInput = form.querySelector('[data-custom-files]');
        if (fileInput?.files?.length) {
          // Send every selected file under the same `file` key (List[UploadFile]).
          Array.from(fileInput.files).forEach((file) => formData.append('file', file));
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }
        if (labelSpan) labelSpan.textContent = 'Sending…';

        try {
          const api = window.WrydecoApi;
          const result =
            api && typeof api.submitConsultation === 'function'
              ? await api.submitConsultation(formData, endpoint)
              : await (async () => {
                  const response = await fetch(endpoint, { method: 'POST', body: formData });
                  let data = null;
                  try {
                    data = await response.json();
                  } catch (parseError) {
                    data = null;
                  }
                  return { ok: response.ok, status: response.status, data };
                })();

          if (result.ok) {
            clearAllErrors();
            notify(successMessage, 'success');
            form.reset();
            form.dispatchEvent(new CustomEvent('consultation:schedule-reset'));
            // Re-sync the file UI (count box, popup, dropzone copy) to the now-empty input.
            if (fileInput) fileInput.dispatchEvent(new Event('change'));
          } else {
            // Surface the API's structured errors instead of a blind generic toast.
            const data = result.data;
            const apiErrors = data && Array.isArray(data.errors) ? data.errors : [];
            if (apiErrors.length) {
              clearAllErrors();
              let firstInvalid = null;
              let mappedAny = false;
              apiErrors.forEach((err) => {
                if (err && errorEls[err.field]) {
                  setFieldError(err.field, err.message || 'This field is invalid.');
                  if (!firstInvalid) firstInvalid = fields[err.field];
                  mappedAny = true;
                }
              });
              if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();
              // Fields now carry the specific errors; if some (e.g. file errors)
              // couldn't be mapped, fall back to the API message so nothing is lost.
              notify(mappedAny ? errorMessage : data.message || errorMessage, 'error');
            } else {
              // File-size / type / server errors: no field, but a clear API message.
              notify((data && data.message) || errorMessage, 'error');
            }
          }
        } catch (error) {
          notify(errorMessage, 'error');
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
          if (labelSpan && originalLabel != null) labelSpan.textContent = originalLabel;
        }
      });
    });

    document.querySelectorAll('[data-custom-files]:not([data-file-initialized])').forEach((input) => {
      input.dataset.fileInitialized = 'true';

      const form = input.closest('form');
      const fileCopy = form?.querySelector('[data-custom-file-copy]');
      const countBtn = form?.querySelector('[data-file-count-trigger]');
      const countNumber = form?.querySelector('[data-file-count-number]');
      const countLabel = form?.querySelector('[data-file-count-label]');
      const popup = form?.querySelector('[data-files-popup]');
      const dialog = popup?.querySelector('.custom-inquiry__files-dialog');
      const list = form?.querySelector('[data-files-list]');

      if (fileCopy && !fileCopy.dataset.defaultCopy) {
        fileCopy.dataset.defaultCopy = fileCopy.textContent;
      }

      const plural = (n) => (n === 1 ? 'file' : 'files');

      const formatSize = (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
      };

      const renderList = (files) => {
        if (!list) return;
        list.textContent = '';
        files.forEach((file) => {
          const item = document.createElement('li');
          item.className = 'custom-inquiry__files-item';
          const name = document.createElement('span');
          name.className = 'custom-inquiry__files-name';
          name.textContent = file.name;
          const size = document.createElement('span');
          size.className = 'custom-inquiry__files-size';
          size.textContent = formatSize(file.size);
          item.append(name, size);
          list.append(item);
        });
      };

      const onKeydown = (event) => {
        if (event.key === 'Escape') closePopup();
      };

      function openPopup() {
        if (!popup || !popup.hidden) return;
        popup.hidden = false;
        // Two frames so the browser paints the hidden state before transitioning.
        requestAnimationFrame(() => requestAnimationFrame(() => popup.classList.add('is-open')));
        countBtn?.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', onKeydown);
        dialog?.focus();
      }

      function closePopup() {
        if (!popup || popup.hidden) return;
        popup.classList.remove('is-open');
        countBtn?.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKeydown);

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          dialog?.removeEventListener('transitionend', onEnd);
          popup.hidden = true;
        };
        const onEnd = (event) => {
          if (event.target === dialog) finish();
        };
        dialog?.addEventListener('transitionend', onEnd);
        // Fallback when transitionend does not fire (e.g. reduced motion).
        setTimeout(finish, 400);
      }

      const syncUi = () => {
        const files = Array.from(input.files || []);
        const count = files.length;

        if (countNumber) countNumber.textContent = count;
        if (countLabel) countLabel.textContent = plural(count);
        if (countBtn) countBtn.hidden = count === 0;
        if (fileCopy) {
          fileCopy.textContent = count > 0 ? `${count} ${plural(count)} selected` : fileCopy.dataset.defaultCopy || '';
        }
        renderList(files);
        if (count === 0) closePopup();
      };

      countBtn?.addEventListener('click', openPopup);
      popup?.querySelectorAll('[data-files-popup-close]').forEach((el) => el.addEventListener('click', closePopup));

      input.addEventListener('change', () => {
        const files = Array.from(input.files || []);
        const tooBig = files.find((file) => file.size > 10 * 1024 * 1024);
        if (tooBig) {
          input.value = '';
          notify('Each file must be 10MB or smaller.', 'error');
        }
        syncUi();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCustomizationInquiry, { once: true });
  } else {
    initializeCustomizationInquiry();
  }

  document.addEventListener('shopify:section:load', initializeCustomizationInquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customization-gallery"] && !Shopify.designMode) return;
  try {
    
  const initializeBeforeAfterGalleries = () => {
    document.querySelectorAll('[data-before-after]:not([data-comparison-ready])').forEach((comparison) => {
      const range = comparison.querySelector('[data-comparison-range]');
      if (!range) return;

      comparison.dataset.comparisonReady = 'true';

      const updateComparison = () => {
        comparison.style.setProperty('--comparison-position', `${range.value}%`);
      };

      range.addEventListener('input', updateComparison);
      updateComparison();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBeforeAfterGalleries, { once: true });
  } else {
    initializeBeforeAfterGalleries();
  }

  document.addEventListener('shopify:section:load', initializeBeforeAfterGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-editorial-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selector = '.faq-editorial';

    function initFaqEditorial(section) {
      if (!section || section.dataset.faqEditorialInit === 'true') {
        return;
      }

      section.dataset.faqEditorialInit = 'true';
      section.addEventListener('click', function (event) {
        var summary = event.target.closest('.faq-editorial-item__summary');
        if (!summary || !section.contains(summary)) {
          return;
        }

        var details = summary.closest('.faq-editorial-item');
        if (!details || details.open) {
          return;
        }

        section.querySelectorAll('.faq-editorial-item[open]').forEach(function (item) {
          if (item !== details) {
            item.open = false;
          }
        });
      });
    }

    function watchFaqEditorial(section) {
      if (!section || section.dataset.faqEditorialObserved === 'true') {
        return;
      }

      section.dataset.faqEditorialObserved = 'true';
      if (!('IntersectionObserver' in window)) {
        initFaqEditorial(section);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            observer.unobserve(entry.target);
            initFaqEditorial(entry.target);
          });
        },
        { rootMargin: '400px 0px' }
      );

      observer.observe(section);
    }

    function watchAllFaqEditorialSections(root) {
      var scope = root || document;
      scope.querySelectorAll(selector).forEach(watchFaqEditorial);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        watchAllFaqEditorialSections(document);
      });
    } else {
      watchAllFaqEditorialSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      watchAllFaqEditorialSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function checkCustomerPosted() {
      if (window.location.href.indexOf('customer_posted=true') !== -1) {
        document.querySelectorAll('[data-newsletter-success]').forEach(function (el) {
          el.hidden = false;
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkCustomerPosted, { once: true });
    } else {
      checkCustomerPosted();
    }

    function initNewsletterForm(form) {
      if (!form || form.dataset.newsletterAjax === 'true') return;
      form.dataset.newsletterAjax = 'true';

      var btn = form.querySelector('[data-newsletter-submit]');
      var successMsg = form.querySelector('[data-newsletter-success]');
      if (!btn) return;

      function toast(message, type) {
        if (window.showToast) {
          window.showToast({ message: message, type: type, position: 'bottom-left' });
        }
      }

      function setLoading(state) {
        if (state) {
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
        } else {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      }

      form.addEventListener('submit', function (event) {
        // Let the browser's native validation handle empty/invalid emails first.
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
        if (btn.getAttribute('aria-busy') === 'true') return;

        event.preventDefault();
        setLoading(true);

        var action = (form.getAttribute('action') || '/contact').split('#')[0];
        var data = new FormData(form);

        fetch(action, { method: 'POST', body: data, redirect: 'follow' })
          .then(function (res) {
            if (!res.ok) {
              form.submit();
              return null;
            }

            return res.text().then(function (html) {
              return {
                url: res.url,
                redirected: res.redirected,
                html: html,
              };
            });
          })
          .then(function (result) {
            if (!result) return;

            var success =
              result.redirected ||
              /customer_posted=true/.test(result.url) ||
              /customer_posted=true/.test(result.html) ||
              /posted_successfully\?/.test(result.html);

            if (!success) {
              setLoading(false);
              toast('We could not subscribe that email. Please try again.', 'error');
              return;
            }

            setLoading(false);
            form.reset();
            if (successMsg) {
              successMsg.hidden = false;
            }
            if (window.WrydecoDiscountAutoApply) {
              window.WrydecoDiscountAutoApply.unlockAndSync();
            } else {
              document.dispatchEvent(new CustomEvent('wry:newsletter-signup-success'));
            }
            toast('Thanks for subscribing.', 'success');
          })
          .catch(function () {
            form.submit();
          });
      });
    }

    function initScheduledSocialLinks() {
      var links = document.querySelectorAll('[data-scheduled-reveal]');
      links.forEach(function (link) {
        var revealTimeStr = link.dataset.scheduledReveal;
        if (!revealTimeStr) return;
        var targetTime = new Date(revealTimeStr).getTime();
        if (isNaN(targetTime)) return;

        function updateVisibility() {
          var now = Date.now();
          if (now >= targetTime) {
            link.style.display = '';
            link.removeAttribute('data-initially-hidden');
          } else {
            link.style.display = 'none';
            var remaining = targetTime - now;
            if (remaining > 0 && remaining < 2147483647) {
              setTimeout(function () {
                link.style.display = '';
                link.removeAttribute('data-initially-hidden');
              }, remaining);
            }
          }
        }

        updateVisibility();
      });
    }

    var initializedMarketplaceLinks = new WeakSet();

    function initMarketplaceLinks() {
      var destinations = new Set([
        'https://www.amazon.com/stores/page/4C9B7557-3277-471F-AEAB-03C34C4284F7',
        'https://etsy.com/shop/BeaconfieldGroup'
      ]);

      document.querySelectorAll('.footer-custom a[data-marketplace-direct]').forEach(function (link) {
        if (initializedMarketplaceLinks.has(link)) return;
        if (!destinations.has(link.href)) return;

        link.addEventListener('click', function (event) {
          if (event.defaultPrevented) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (!destinations.has(link.href)) return;

          event.preventDefault();
          window.open(link.href, '_blank', 'noopener,noreferrer');
        });
        initializedMarketplaceLinks.add(link);
      });
    }

    initMarketplaceLinks();
    initScheduledSocialLinks();
    document.querySelectorAll('.footer-custom__form').forEach(initNewsletterForm);
    document.addEventListener('shopify:section:load', function () {
      checkCustomerPosted();
      document.querySelectorAll('.footer-custom__form').forEach(initNewsletterForm);
      initScheduledSocialLinks();
      initMarketplaceLinks();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initMegaMenu() {
      var groups = Array.prototype.slice.call(document.querySelectorAll('[data-mega-group]'));
      groups.forEach(function (group) {
        var toggle = group.querySelector('[data-mega-toggle]');
        var panel = group.querySelector('.cmega__panel');
        if (!toggle || toggle.dataset.init === 'true') return;
        toggle.dataset.init = 'true';
        if (panel) panel.inert = true;
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          var willOpen = !group.classList.contains('is-open');
          // Single-open accordion: collapse the others first.
          groups.forEach(function (other) {
            if (other === group) return;
            other.classList.remove('is-open');
            var t = other.querySelector('[data-mega-toggle]');
            var otherPanel = other.querySelector('.cmega__panel');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.inert = true;
          });
          group.classList.toggle('is-open', willOpen);
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (panel) panel.inert = !willOpen;
        });
      });

      // Fix for desktop mega menu staying open after click (due to :focus-within)
      var desktopItems = document.querySelectorAll('.header__nav-item-has-mega-menu');
      desktopItems.forEach(function (item) {
        item.addEventListener('mouseleave', function () {
          if (item.contains(document.activeElement)) {
            document.activeElement.blur();
          }
        });
      });
    }

    function initMobileMenu() {
      var trigger = document.querySelector('[data-mobile-menu-open]');
      var drawer = document.querySelector('[data-mobile-menu-drawer]');
      if (!trigger || !drawer || drawer.dataset.mobileMenuInit === 'true') return;

      drawer.dataset.mobileMenuInit = 'true';
      var panel = drawer.querySelector('.cmega');
      var closeButtons = Array.prototype.slice.call(drawer.querySelectorAll('[data-mobile-menu-close]'));
      var mobileQuery = window.matchMedia('(width < 53.75rem)');
      var previousFocus = null;

      function closeMenu(restoreFocus) {
        drawer.classList.remove('is-mobile-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mobile-menu-is-open');
        if (mobileQuery.matches) drawer.setAttribute('aria-hidden', 'true');
        if (restoreFocus && previousFocus instanceof HTMLElement) previousFocus.focus();
      }

      function openMenu() {
        if (!mobileQuery.matches) return;
        previousFocus = document.activeElement;
        drawer.classList.add('is-mobile-open');
        drawer.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mobile-menu-is-open');
        window.requestAnimationFrame(function () {
          var closeButton = drawer.querySelector('.mobile-menu__close');
          if (closeButton) closeButton.focus();
        });
      }

      function syncMode() {
        closeMenu(false);
        if (mobileQuery.matches) {
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-modal', 'true');
          drawer.setAttribute('aria-label', 'Shop by category');
          drawer.setAttribute('aria-hidden', 'true');
        } else {
          drawer.removeAttribute('role');
          drawer.removeAttribute('aria-modal');
          drawer.removeAttribute('aria-label');
          drawer.removeAttribute('aria-hidden');
        }
      }

      trigger.addEventListener('click', openMenu);
      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          closeMenu(true);
        });
      });

      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a') && mobileQuery.matches) closeMenu(false);
      });

      document.addEventListener('keydown', function (event) {
        if (!drawer.classList.contains('is-mobile-open')) return;
        if (event.key === 'Escape') {
          closeMenu(true);
          return;
        }
        if (event.key !== 'Tab' || !panel) return;

        var focusable = Array.prototype.slice
          .call(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter(function (element) {
            return element.offsetParent !== null && !element.closest('[inert]');
          });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncMode);
      syncMode();
    }

    var initializedMarketplaceLinks = new WeakSet();

    function initMarketplaceLinks() {
      var destinations = new Set([
        'https://www.amazon.com/stores/page/4C9B7557-3277-471F-AEAB-03C34C4284F7',
        'https://etsy.com/shop/BeaconfieldGroup'
      ]);

      document.querySelectorAll('.header a[data-marketplace-direct]').forEach(function (link) {
        if (initializedMarketplaceLinks.has(link)) return;
        if (!destinations.has(link.href)) return;

        link.addEventListener('click', function (event) {
          if (event.defaultPrevented) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (!destinations.has(link.href)) return;

          event.preventDefault();
          window.open(link.href, '_blank', 'noopener,noreferrer');
        });
        initializedMarketplaceLinks.add(link);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initMegaMenu();
        initMobileMenu();
        initMarketplaceLinks();
      });
    } else {
      initMegaMenu();
      initMobileMenu();
      initMarketplaceLinks();
    }

    document.addEventListener('shopify:section:load', function () {
      initMegaMenu();
      initMobileMenu();
      initMarketplaceLinks();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider() {
      var hero = document.getElementById('homepage-hero-new');
      if (!hero) return;

      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      if (slides.length <= 1) return;

      if (hero.dataset.sliderInitialized === 'true') return;
      hero.dataset.sliderInitialized = 'true';

      var currentIndex = 0;
      var intervalTime = parseInt(hero.dataset.interval, 10) || 4000;
      var timer = null;

      function goToSlide(nextIndex) {
        if (nextIndex === currentIndex) return;

        var prevSlide = slides[currentIndex];
        var nextSlide = slides[nextIndex];

        slides.forEach(function (slide) {
          slide.classList.remove('is-prev');
        });

        prevSlide.classList.add('is-prev');
        prevSlide.classList.remove('is-active');

        nextSlide.classList.add('is-active');
        currentIndex = nextIndex;

        setTimeout(function () {
          prevSlide.classList.remove('is-prev');
        }, 1250);
      }

      function nextSlide() {
        var next = (currentIndex + 1) % slides.length;
        goToSlide(next);
      }

      function startTimer() {
        stopTimer();
        timer = setInterval(nextSlide, intervalTime);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!motionQuery.matches) {
        startTimer();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopTimer();
        } else if (!motionQuery.matches) {
          startTimer();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroSlider);
    } else {
      initHeroSlider();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('#homepage-hero-new')) {
        var hero = event.target.querySelector('#homepage-hero-new');
        if (hero) hero.removeAttribute('data-slider-initialized');
        initHeroSlider();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loox-product-reviews-heading"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLooxReviewsLoading() {
      document.querySelectorAll('[data-loox-reviews-section]').forEach(function (section) {
        if (section.dataset.looxLoadingInit === 'true') return;

        var loader = section.querySelector('[data-loox-reviews-loading]');
        var app = section.querySelector('[data-loox-reviews-app]');
        if (!loader || !app) return;

        section.dataset.looxLoadingInit = 'true';

        function isVisibleElement(element) {
          if (!element) return false;
          var rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        }

        function hasLoadedReviews() {
          var reviewNodes = app.querySelectorAll(
            'iframe, article, [role="article"], .loox-review, .loox-review-card, [class*="review"], [data-testid*="review"]'
          );

          for (var i = 0; i < reviewNodes.length; i += 1) {
            var node = reviewNodes[i];
            if (isVisibleElement(node) || node.textContent.trim().length > 24) return true;
          }

          return app.children.length > 0 && app.scrollHeight > 180 && app.textContent.trim().length > 24;
        }

        function hideLoader() {
          loader.hidden = true;
          section.setAttribute('aria-busy', 'false');
        }

        function checkLoaded() {
          if (loader.hidden) return;
          if (hasLoadedReviews()) {
            hideLoader();
          }
        }

        var observer = new MutationObserver(checkLoaded);
        observer.observe(app, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
        });

        window.addEventListener('load', checkLoaded, { once: true });
        window.setTimeout(checkLoaded, 600);
        window.setTimeout(function () {
          if (loader.hidden) return;
          loader.classList.add('loox-product-reviews-heading__loading--slow');
          var message = loader.querySelector('[data-loox-reviews-loading-message]');
          if (message) message.textContent = 'Reviews are taking a little longer to appear';
        }, 8000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLooxReviewsLoading);
    } else {
      initLooxReviewsLoading();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-about-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealSelector = '[data-about-reveal]';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let revealObserver = null;

    const revealAll = (scope = document) => {
      scope.querySelectorAll(revealSelector).forEach((element) => element.classList.add('is-revealed'));
    };

    const initializeRevealEffects = (scope = document) => {
      const sections = Array.from(scope.querySelectorAll(revealSelector)).filter(
        (element) => element.dataset.aboutRevealReady !== 'true'
      );
      if (sections.length === 0) return;

      if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
        sections.forEach((section) => {
          section.dataset.aboutRevealReady = 'true';
          section.classList.add('is-revealed');
        });
        return;
      }

      document.documentElement.classList.add('about-reveal-enabled');

      if (!revealObserver) {
        revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            });
          },
          {
            rootMargin: '0% 0% -10% 0%',
            threshold: 0.12,
          }
        );
      }

      sections.forEach((section) => {
        section.dataset.aboutRevealReady = 'true';
        revealObserver.observe(section);
      });
    };

    const initializeAllRevealEffects = () => {
      initializeRevealEffects(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllRevealEffects);
    } else {
      initializeAllRevealEffects();
    }

    document.addEventListener('shopify:section:load', (event) => initializeRevealEffects(event.target));
    prefersReducedMotion.addEventListener('change', (event) => {
      if (!event.matches) return;
      document.documentElement.classList.remove('about-reveal-enabled');
      revealAll();
      revealObserver?.disconnect();
      revealObserver = null;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  const showContactToasts = (attempt = 0) => {
    const feedbackItems = document.querySelectorAll('[data-contact-toast]:not([data-toast-shown])');
    if (!feedbackItems.length) return;

    if (typeof window.showToast !== 'function') {
      if (attempt < 20) {
        window.setTimeout(() => showContactToasts(attempt + 1), 100);
      }
      return;
    }

    feedbackItems.forEach((feedback) => {
      feedback.dataset.toastShown = 'true';
      window.showToast({
        message: feedback.dataset.toastMessage,
        type: feedback.dataset.toastType,
        position: 'bottom-left',
        duration: 4000,
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showContactToasts, { once: true });
  } else {
    showContactToasts();
  }
  window.addEventListener('load', showContactToasts, { once: true });
  document.addEventListener('shopify:section:load', showContactToasts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-faq-filter]');
    if (!filterButton) return;

    const faqPage = filterButton.closest('.faq-page');
    if (!faqPage) return;

    const selectedCategory = filterButton.dataset.faqFilter;
    const categoryButtons = faqPage.querySelectorAll('[data-faq-filter]');
    const questionRows = faqPage.querySelectorAll('[data-faq-category]');
    const consultationCard = faqPage.querySelector('[data-faq-consultation]');

    categoryButtons.forEach((button) => {
      const isSelected = button === filterButton;
      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-selected', String(isSelected));
    });

    questionRows.forEach((row) => {
      const matchesPrimary = row.dataset.faqCategory === selectedCategory;
      const matchesSecondary = row.dataset.faqSecondaryCategory === selectedCategory;
      row.hidden = selectedCategory !== 'all' && !matchesPrimary && !matchesSecondary;
    });

    if (consultationCard) {
      consultationCard.hidden = selectedCategory !== 'all' && selectedCategory !== 'consultation';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initStickyAddToCart() {
      var bar = document.querySelector('[data-mp-sticky]');
      if (!bar || bar.dataset.init === 'true') return;

      var formId = bar.getAttribute('data-form-id');
      var form = document.getElementById(formId);
      if (!form) return;

      var mainBtn = form.querySelector('button[name="add"]');
      var mainQty = form.querySelector('.quantity-input__input');
      var mainText = form.querySelector('[data-add-to-cart-text]');
      if (!mainBtn || !mainQty) return;

      bar.dataset.init = 'true';
      bar.hidden = false;

      var stickyQtyInput = bar.querySelector('[data-mp-sticky-qty-input]');
      var stickyQtyBtns = bar.querySelectorAll('[data-mp-sticky-qty] [data-action]');
      var stickyAdd = bar.querySelector('[data-mp-sticky-add]');
      var stickyAddText = bar.querySelector('[data-mp-sticky-add-text]');
      var stickyPrice = bar.querySelector('[data-mp-sticky-price]');
      var mainPrice = document.querySelector('[data-regular-price]');

      function readQty() {
        var v = parseInt(mainQty.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        return v;
      }

      // Quantity is kept in sync with the main form input (single source of truth).
      function setQty(val) {
        if (val < 1) val = 1;
        mainQty.value = val;
        stickyQtyInput.value = val;
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      stickyQtyInput.value = readQty();

      stickyQtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = readQty();
          setQty(btn.dataset.action === 'increase' ? val + 1 : val - 1);
        });
      });
      stickyQtyInput.addEventListener('change', function () {
        setQty(parseInt(stickyQtyInput.value, 10) || 1);
      });

      // Reuse the main form's add-to-cart logic (product-form.js) verbatim by
      // pushing the chosen quantity into the main form and submitting it.
      stickyAdd.addEventListener('click', function () {
        if (stickyAdd.disabled || stickyAdd.classList.contains('is-loading')) return;
        setQty(readQty());
        stickyAdd.classList.add('is-loading');
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
        // Clear the loading state once the cart update lands (or as a fallback).
        var clear = function () {
          stickyAdd.classList.remove('is-loading');
        };
        document.addEventListener('cart:updated', clear, { once: true });
        setTimeout(clear, 5000);
      });

      // Mirror the primary button's availability/label and the live price so the
      // bar always reflects the current variant.
      function syncFromMain() {
        stickyAdd.disabled = mainBtn.hasAttribute('disabled');
        if (mainText && stickyAddText && !mainBtn.classList.contains('loading')) {
          stickyAddText.textContent = mainText.textContent.trim();
        }
        if (mainPrice && stickyPrice) {
          stickyPrice.textContent = mainPrice.textContent.trim();
        }
      }
      syncFromMain();
      if (window.MutationObserver) {
        new MutationObserver(syncFromMain).observe(form, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });
        if (mainPrice) {
          new MutationObserver(syncFromMain).observe(mainPrice, {
            childList: true,
            characterData: true,
            subtree: true,
          });
        }
      }

      // Show the bar only once the user has scrolled DOWN past the add-to-cart
      // button — i.e. the viewport's top edge is below the button (the whole
      // button has scrolled above the top of the screen). It stays hidden while
      // the button is still below the fold (not yet reached).
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var scrolledPast = entry.boundingClientRect.bottom <= 0;
              bar.classList.toggle('is-visible', scrolledPast);
              bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
              if (scrolledPast) {
                bar.removeAttribute('inert');
              } else {
                bar.setAttribute('inert', '');
              }
            });
          },
          { root: null, rootMargin: '0px', threshold: 0 }
        );
        io.observe(mainBtn);
      }
    }

    function initRatingReviewLinks() {
      document.querySelectorAll('[data-product-rating-link]').forEach(function (link) {
        if (link.dataset.ratingLinkInit === 'true') return;
        link.dataset.ratingLinkInit = 'true';

        link.addEventListener('click', function (event) {
          var target = document.querySelector('.loox-product-reviews-heading__inner');
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });

          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#ProductReviews');
          }
        });
      });
    }

    function initMainProductEnhancements() {
      initRatingReviewLinks();
      initStickyAddToCart();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMainProductEnhancements);
    } else {
      initMainProductEnhancements();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-the-makers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function renderFallbackFeatures(root) {
      root.querySelectorAll('[data-maker-features]').forEach(function (container) {
        if (container.dataset.makerFeaturesInit === 'true') return;
        container.dataset.makerFeaturesInit = 'true';

        try {
          var data = JSON.parse(container.getAttribute('data-maker-features') || '[]');
          if (typeof data === 'string') data = JSON.parse(data);
          var features = Array.isArray(data) ? data : data.features;
          if (!Array.isArray(features)) return;

          features.forEach(function (feature, index) {
            var item = document.createElement('div');
            item.className = 'maker-feature' + (index > 0 ? ' maker-feature--border' : '');

            var label = document.createElement('span');
            label.append(document.createTextNode(feature.value || ''));
            label.append(document.createElement('br'));
            label.append(document.createTextNode(feature.label || ''));
            item.append(label);
            container.append(item);
          });
        } catch (error) {
          container.hidden = true;
        }
      });
    }

    function initCarousel(carousel) {
      if (!carousel || carousel.dataset.makerInit === 'true') return;
      carousel.dataset.makerInit = 'true';
      renderFallbackFeatures(carousel);

      var slider = carousel.querySelector('[data-maker-slider]');
      if (!slider) return;

      var prevButton = carousel.querySelector('[data-maker-prev]');
      var nextButton = carousel.querySelector('[data-maker-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-maker-dot]'));
      var cards = Array.prototype.slice.call(slider.querySelectorAll('.maker-card'));
      var activeFrame = 0;
      var scrollFrame = null;
      var resizeTimer = null;
      var lockedActiveFrame = null;

      function getFramePositions() {
        var maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
        var positions = [];

        cards.forEach(function (card) {
          var targetLeft = card.offsetLeft - slider.offsetLeft;
          var frameLeft = Math.min(Math.max(0, targetLeft), maxLeft);
          var lastLeft = positions[positions.length - 1];

          if (positions.length === 0 || Math.abs(frameLeft - lastLeft) > 1) {
            positions.push(frameLeft);
          }
        });

        return positions.length ? positions : [0];
      }

      function getFrameCount() {
        return getFramePositions().length;
      }

      function getFrameLeft(frame) {
        var positions = getFramePositions();
        return positions[Math.min(Math.max(frame, 0), positions.length - 1)] || 0;
      }

      function updateCarouselState() {
        var frameCount = getFrameCount();
        activeFrame = Math.min(Math.max(activeFrame, 0), frameCount - 1);

        if (prevButton) prevButton.disabled = activeFrame === 0;
        if (nextButton) nextButton.disabled = activeFrame >= frameCount - 1;

        dots.forEach(function (dot, index) {
          var isActive = index === activeFrame;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          dot.hidden = index >= frameCount;
        });
      }

      function goToFrame(frame, behavior) {
        activeFrame = Math.min(Math.max(frame, 0), getFrameCount() - 1);
        lockedActiveFrame = activeFrame;
        slider.scrollTo({ left: getFrameLeft(activeFrame), behavior: behavior || 'smooth' });
        updateCarouselState();
        window.setTimeout(function () {
          lockedActiveFrame = null;
          syncActiveFrameFromScroll();
        }, behavior === 'auto' ? 0 : 700);
      }

      function syncActiveFrameFromScroll() {
        scrollFrame = null;
        if (lockedActiveFrame !== null) return;

        var positions = getFramePositions();
        var frameCount = positions.length;
        var closestFrame = 0;
        var closestDistance = Infinity;
        for (var frame = 0; frame < frameCount; frame += 1) {
          var distance = Math.abs(slider.scrollLeft - positions[frame]);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestFrame = frame;
          }
        }
        activeFrame = closestFrame;
        updateCarouselState();
      }

      carousel.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-maker-dot]');
        if (dot) {
          goToFrame(Number(dot.dataset.makerFrame || 0));
          return;
        }

        if (event.target.closest('[data-maker-prev]')) {
          goToFrame(activeFrame - 1);
          return;
        }

        if (event.target.closest('[data-maker-next]')) {
          goToFrame(activeFrame + 1);
        }
      });

      slider.addEventListener(
        'scroll',
        function () {
          if (scrollFrame !== null) return;
          scrollFrame = window.requestAnimationFrame(syncActiveFrameFromScroll);
        },
        { passive: true }
      );

      function handleResize() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          goToFrame(activeFrame, 'auto');
        }, 120);
      }

      window.addEventListener('resize', handleResize);
      carousel.addEventListener('dragstart', function (event) {
        if (event.target.closest('.maker-card__img-link, .maker-card__img')) event.preventDefault();
      });

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var isDragging = false;
      var dragThreshold = 5;

      slider.addEventListener('mousedown', function (event) {
        isDown = true;
        isDragging = false;
        startX = event.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      function endDrag() {
        isDown = false;
        slider.classList.remove('is-dragging');
      }

      slider.addEventListener('mouseleave', endDrag);
      slider.addEventListener('mouseup', endDrag);

      slider.addEventListener('mousemove', function (event) {
        if (!isDown) return;
        var x = event.pageX - slider.offsetLeft;
        if (!isDragging && Math.abs(x - startX) > dragThreshold) {
          isDragging = true;
          slider.classList.add('is-dragging');
        }
        if (!isDragging) return;
        event.preventDefault();
        slider.scrollLeft = scrollLeft - (x - startX) * 2;
      });

      slider.addEventListener('click', function (event) {
        if (isDragging) event.preventDefault();
      });

      updateCarouselState();
    }

    function scheduleCarousel(carousel) {
      if (!('IntersectionObserver' in window)) {
        initCarousel(carousel);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            initCarousel(entry.target);
          });
        },
        { rootMargin: '400px 0px' }
      );

      observer.observe(carousel);
    }

    function initMeetMakers(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-maker-carousel]').forEach(scheduleCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initMeetMakers(document);
      });
    } else {
      initMeetMakers(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initMeetMakers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-process-delivery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeOrderProcess = (root = document) => {
      root.querySelectorAll('.order-process').forEach((section) => {
        section.querySelectorAll('[data-order-process-toggle]').forEach((toggle) => {
          if (toggle.dataset.orderProcessReady === 'true') return;

          const panelId = toggle.getAttribute('aria-controls');
          const panel = panelId ? document.getElementById(panelId) : null;
          if (!panel) return;

          toggle.dataset.orderProcessReady = 'true';
          toggle.addEventListener('click', () => {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!isExpanded));
            panel.hidden = isExpanded;
          });
        });
      });
    };

    initializeOrderProcess();
    document.addEventListener('shopify:section:load', (event) => initializeOrderProcess(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  window.initPairsCarousels = function () {
    document.querySelectorAll('[data-pairs-carousel]').forEach(function (carousel) {
      if (carousel.dataset.pairsInit === 'true') return;
      carousel.dataset.pairsInit = 'true';

      var slider = carousel.querySelector('[data-pairs-slider]');
      if (!slider) return;
      var prev = carousel.querySelector('[data-pairs-prev]');
      var next = carousel.querySelector('[data-pairs-next]');
      var navFrame = null;

      function pageWidth() {
        var card = slider.querySelector('.pairs-card');
        var styles = getComputedStyle(slider);
        var gap = parseFloat(styles.columnGap || styles.gap) || 16;
        if (!card) return slider.clientWidth;
        var cardWidth = card.getBoundingClientRect().width + gap;
        var perView = Math.max(1, Math.round(slider.clientWidth / cardWidth));
        return cardWidth * perView;
      }

      function framePositions() {
        var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
        var step = pageWidth();
        var positions = [0];

        if (maxScroll <= 1) return positions;
        if (step <= 1) return [0, maxScroll];

        for (var left = step; left < maxScroll - 1; left += step) {
          positions.push(left);
        }

        if (maxScroll - positions[positions.length - 1] > 1) {
          positions.push(maxScroll);
        }

        return positions;
      }

      function targetFrame(direction) {
        var positions = framePositions();
        var scrollLeft = slider.scrollLeft;

        if (direction > 0) {
          for (var nextIndex = 0; nextIndex < positions.length; nextIndex += 1) {
            if (positions[nextIndex] > scrollLeft + 1) return positions[nextIndex];
          }

          return positions[positions.length - 1];
        }

        for (var prevIndex = positions.length - 1; prevIndex >= 0; prevIndex -= 1) {
          if (positions[prevIndex] < scrollLeft - 1) return positions[prevIndex];
        }

        return positions[0];
      }

      function updateNav() {
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        carousel.classList.toggle('has-overflow', maxScroll > 1);
        if (prev) prev.disabled = slider.scrollLeft <= 1;
        if (next) next.disabled = slider.scrollLeft >= maxScroll - 1;
      }

      function scheduleNavUpdate() {
        if (navFrame !== null) return;
        navFrame = window.requestAnimationFrame(function () {
          navFrame = null;
          updateNav();
        });
      }

      if (prev) prev.addEventListener('click', function () {
        slider.scrollTo({ left: targetFrame(-1), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        slider.scrollTo({ left: targetFrame(1), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', scheduleNavUpdate, { passive: true });
      window.addEventListener('resize', scheduleNavUpdate);
      updateNav();

      // Press-and-drag to scroll (mouse). Uses a small threshold so a plain
      // click still activates the card link.
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var isDragging = false;
      var THRESHOLD = 5;

      slider.addEventListener('mousedown', function (e) {
        isDown = true;
        isDragging = false;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      function endDrag() {
        isDown = false;
        slider.classList.remove('is-dragging');
      }
      slider.addEventListener('mouseleave', endDrag);
      slider.addEventListener('mouseup', endDrag);

      slider.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - slider.offsetLeft;
        if (!isDragging && Math.abs(x - startX) > THRESHOLD) {
          isDragging = true;
          slider.classList.add('is-dragging');
        }
        if (!isDragging) return;
        e.preventDefault();
        slider.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });

      // Suppress the click that follows a real drag so links don't navigate.
      slider.addEventListener(
        'click',
        function (e) {
          if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      // Never start a native image/link drag-and-drop.
      slider.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initPairsCarousels);
  } else {
    window.initPairsCarousels();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rich-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRichDescriptionImages() {
      document.querySelectorAll('.product-rich-description__content img[data-src]').forEach(function (image) {
        var richSource = image.getAttribute('data-src');
        if (!richSource) return;
        image.setAttribute('src', richSource);
        image.removeAttribute('data-src');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRichDescriptionImages);
    } else {
      initRichDescriptionImages();
    }

    document.addEventListener('shopify:section:load', initRichDescriptionImages);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-spaces-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-real-spaces]:not([data-real-spaces-ready])');

    roots.forEach((root) => {
      root.dataset.realSpacesReady = 'true';

      root.querySelectorAll('[data-project-grid]').forEach((slider) => {
        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let wasDragged = false;

        slider.addEventListener('pointerdown', (event) => {
          if (getComputedStyle(slider).display !== 'flex') return;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = slider.scrollLeft;
          wasDragged = false;
        });

        slider.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointerId) return;
          const distance = event.clientX - startX;
          if (Math.abs(distance) > 5) {
            wasDragged = true;
            slider.classList.add('is-dragging');
            if (!slider.hasPointerCapture(pointerId)) slider.setPointerCapture(pointerId);
          }
          if (wasDragged) slider.scrollLeft = startScrollLeft - distance;
        });

        const endDrag = (event) => {
          if (event.pointerId !== pointerId) return;
          if (slider.hasPointerCapture(pointerId)) slider.releasePointerCapture(pointerId);
          pointerId = null;
          slider.classList.remove('is-dragging');
        };

        slider.addEventListener('pointerup', endDrag);
        slider.addEventListener('pointercancel', endDrag);
        slider.addEventListener('lostpointercapture', () => {
          pointerId = null;
          slider.classList.remove('is-dragging');
        });
        slider.addEventListener('dragstart', (event) => event.preventDefault());
        slider.addEventListener(
          'click',
          (event) => {
            if (!wasDragged) return;
            event.preventDefault();
            event.stopPropagation();
            wasDragged = false;
          },
          true
        );
      });

      root.querySelectorAll('[data-project-card]').forEach((card) => {
        card.addEventListener('click', (event) => {
          if (event.target.closest('a, button')) return;
          const trigger = card.querySelector('[data-lightbox-trigger]');
          if (trigger) trigger.click();
        });
      });

      const viewportVideos = root.querySelectorAll('[data-viewport-video]');
      viewportVideos.forEach((video) => {
        video.addEventListener('playing', () => video.classList.add('is-playing'));
        video.addEventListener('pause', () => video.classList.remove('is-playing'));
      });
      const startViewportVideos = () => {
        if (!('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                if (!video.src && video.dataset.src) {
                  video.src = video.dataset.src;
                  video.load();
                }
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.5, 1] }
        );
        viewportVideos.forEach((video) => observer.observe(video));
      };

      if (document.readyState === 'complete') startViewportVideos();
      else window.addEventListener('load', startViewportVideos, { once: true });

      const lightbox = root.querySelector('[data-lightbox]');
      const dialog = root.querySelector('.real-spaces-lightbox__dialog');
      const lightboxContent = root.querySelector('.real-spaces-lightbox__content');
      const stage = root.querySelector('[data-lightbox-stage]');
      const counter = root.querySelector('[data-lightbox-counter]');
      const title = root.querySelector('[data-lightbox-title]');
      const projectLabel = root.querySelector('[data-lightbox-label]');
      const projectAuthor = root.querySelector('[data-lightbox-author]');
      const projectDescription = root.querySelector('[data-lightbox-description]');
      const productLink = root.querySelector('[data-lightbox-product]');
      const thumbnails = root.querySelector('[data-lightbox-thumbnails]');
      const previousButton = root.querySelector('[data-lightbox-previous]');
      const nextButton = root.querySelector('[data-lightbox-next]');
      const closeButton = root.querySelector('.real-spaces-lightbox__close');
      let mediaItems = [];
      let currentIndex = 0;
      let poster = '';
      let returnFocus = null;
      let touchStartX = 0;

      const isVideo = (url) => /\.(mp4|webm|mov)(?:$|\?)/i.test(url);

      const renderLightbox = () => {
        const url = mediaItems[currentIndex];
        const outgoingVideo = stage.querySelector('video');
        if (outgoingVideo) outgoingVideo.pause();
        stage.replaceChildren();

        let media;
        if (isVideo(url)) {
          media = document.createElement('video');
          media.src = url;
          media.poster = poster;
          media.controls = true;
          media.playsInline = true;
          media.preload = 'none';
          media.muted = true;
          media.autoplay = true;
        } else {
          media = document.createElement('img');
          media.src = url;
          media.alt = title.textContent;
        }
        stage.append(media);
        counter.textContent = `${currentIndex + 1} / ${mediaItems.length}`;
        thumbnails.querySelectorAll('button').forEach((button, index) => {
          button.setAttribute('aria-pressed', String(index === currentIndex));
        });
        const activeThumbnail = thumbnails.children[currentIndex];
        if (activeThumbnail) {
          const left = activeThumbnail.offsetLeft - thumbnails.offsetLeft;
          if (left < thumbnails.scrollLeft) thumbnails.scrollLeft = left;
          else if (left + activeThumbnail.offsetWidth > thumbnails.scrollLeft + thumbnails.clientWidth) {
            thumbnails.scrollLeft = left + activeThumbnail.offsetWidth - thumbnails.clientWidth;
          }
        }
      };

      const buildThumbnails = () => {
        thumbnails.replaceChildren();
        mediaItems.forEach((url, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'real-spaces-lightbox__thumbnail';
          button.setAttribute('aria-label', `View ${isVideo(url) ? 'video' : 'image'} ${index + 1}`);
          const thumbnailUrl = isVideo(url) ? poster : url;
          if (thumbnailUrl) {
            const thumbnail = document.createElement('img');
            thumbnail.src = thumbnailUrl;
            thumbnail.alt = '';
            thumbnail.loading = 'lazy';
            thumbnail.decoding = 'async';
            button.append(thumbnail);
          }
          if (isVideo(url)) {
            const videoLabel = document.createElement('span');
            videoLabel.textContent = 'Video';
            button.append(videoLabel);
          }
          button.addEventListener('click', () => {
            currentIndex = index;
            renderLightbox();
          });
          thumbnails.append(button);
        });
        previousButton.disabled = mediaItems.length < 2;
        nextButton.disabled = mediaItems.length < 2;
      };

      const move = (direction) => {
        currentIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
        renderLightbox();
      };

      const closeLightbox = () => {
        const activeVideo = stage.querySelector('video');
        if (activeVideo) activeVideo.pause();
        lightbox.hidden = true;
        document.body.classList.remove('real-spaces-lightbox-open');
        if (returnFocus) returnFocus.focus();
      };

      root.querySelectorAll('[data-lightbox-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          mediaItems = trigger.dataset.gallery
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean);
          if (!mediaItems.length) return;
          currentIndex = 0;
          poster = trigger.dataset.poster || '';
          title.textContent = trigger.dataset.title || 'Project gallery';
          projectLabel.textContent = trigger.dataset.featured === 'true' ? 'Featured project' : 'Client project';
          projectAuthor.replaceChildren();
          projectAuthor.hidden = !trigger.dataset.author;
          if (trigger.dataset.author) {
            projectAuthor.append('Crafted by ');
            if (trigger.dataset.authorUrl) {
              const authorLink = document.createElement('a');
              authorLink.href = trigger.dataset.authorUrl;
              authorLink.textContent = trigger.dataset.author;
              projectAuthor.append(authorLink);
            } else projectAuthor.append(trigger.dataset.author);
          }
          projectDescription.textContent = trigger.dataset.description ||
            'Explore the images and videos documenting this WRYDECO piece, handcrafted to order.';
          productLink.hidden = !trigger.dataset.productUrl;
          if (trigger.dataset.productUrl) productLink.href = trigger.dataset.productUrl;
          buildThumbnails();
          returnFocus = trigger;
          lightbox.hidden = false;
          dialog.scrollTop = 0;
          lightboxContent.scrollTop = 0;
          thumbnails.scrollLeft = 0;
          document.body.classList.add('real-spaces-lightbox-open');
          renderLightbox();
          closeButton.focus();
        });
      });

      root
        .querySelectorAll('[data-lightbox-close]')
        .forEach((control) => control.addEventListener('click', closeLightbox));
      previousButton.addEventListener('click', () => move(-1));
      nextButton.addEventListener('click', () => move(1));

      stage.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      stage.addEventListener(
        'touchend',
        (event) => {
          const delta = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(delta) > 48) move(delta > 0 ? -1 : 1);
        },
        { passive: true }
      );

      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
        if (event.key === 'Tab') {
          const focusable = Array.from(lightbox.querySelectorAll('button:not([disabled]), a[href], video[controls]'))
            .filter((element) => element.getClientRects().length > 0);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-pieces"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Nudge the Vitals wishlist app to (re)render its heart icons on the cards.
    function requestWishlistRender() {
      document.dispatchEvent(new CustomEvent('vitals:ProductCardsDetected'));
      document.dispatchEvent(new CustomEvent('vitals:RenderWishlistIcons'));
      window.dispatchEvent(new CustomEvent('vitals:ProductCardsDetected'));
      window.dispatchEvent(new CustomEvent('vitals:RenderWishlistIcons'));
    }

    function initWishlist(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-signature-wishlist]').forEach(function (btn) {
        if (btn.dataset.init === 'true') return;
        btn.dataset.init = 'true';
        btn.addEventListener('click', function () {
          requestWishlistRender();
        });
      });
      requestWishlistRender();
    }

    // Hover gallery: cycle through the card's images while the pointer is over
    // it, cross-fading each frame. Mirrors the collection (PLP) product card.
    function loadDeferredGalleryImages(gallery) {
      gallery.querySelectorAll('img[data-src]').forEach(function (image) {
        image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
      });
    }

    function hydrateHoverGallery(gallery) {
      var template = gallery.querySelector('[data-sp-hover-template]');
      if (template) {
        gallery.appendChild(template.content.cloneNode(true));
        template.remove();
      }
      loadDeferredGalleryImages(gallery);
    }

    var hoverGalleryObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrateHoverGallery(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '300px 0px' })
      : null;

    function initHoverGallery(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-sp-hover-gallery]').forEach(function (gallery) {
        if (gallery.dataset.initHover === 'true') return;
        gallery.dataset.initHover = 'true';

        var images = gallery.querySelectorAll('.signature-pieces__image');
        var template = gallery.querySelector('[data-sp-hover-template]');
        if (images.length <= 1 && !template) return;

        var intervalId = null;
        var currentIndex = 0;

        if (hoverGalleryObserver) {
          hoverGalleryObserver.observe(gallery);
        } else {
          hydrateHoverGallery(gallery);
          images = gallery.querySelectorAll('.signature-pieces__image');
        }

        function showImage(index) {
          images.forEach(function (img) {
            img.classList.remove('is-prev');
            if (img.classList.contains('is-active')) {
              img.classList.remove('is-active');
              img.classList.add('is-prev');
            }
          });
          images[index].classList.add('is-active');
        }

        gallery.addEventListener('mouseenter', function () {
          hydrateHoverGallery(gallery);
          images = gallery.querySelectorAll('.signature-pieces__image');
          if (images.length <= 1) return;
          currentIndex = 1;
          showImage(currentIndex);

          intervalId = setInterval(function () {
            currentIndex = (currentIndex + 1) % images.length;
            showImage(currentIndex);
          }, 2000);
        });

        gallery.addEventListener('mouseleave', function () {
          clearInterval(intervalId);
          currentIndex = 0;
          showImage(0);
        });
      });
    }

    function initCardLinks(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.signature-pieces__card[data-product-url]').forEach(function (card) {
        if (card.dataset.cardLinkInit === 'true') return;
        card.dataset.cardLinkInit = 'true';

        card.addEventListener('click', function (event) {
          if (event.defaultPrevented) return;
          if (event.target.closest('a, button, input, select, textarea, [role="button"], [data-signature-wishlist]')) {
            return;
          }

          window.location.assign(card.dataset.productUrl);
        });
      });
    }

    function initCarousel(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-signature-carousel]').forEach(function (carousel) {
        if (carousel.dataset.carouselInit === 'true') return;

        var section = carousel.closest('.signature-pieces');
        var controls = section && section.querySelector('[data-signature-carousel-controls]');
        var previousButton = controls && controls.querySelector('[data-signature-carousel-previous]');
        var nextButton = controls && controls.querySelector('[data-signature-carousel-next]');
        if (!section || !controls || !previousButton || !nextButton) return;

        carousel.dataset.carouselInit = 'true';
        var updateFrame = null;
        var carouselMetrics = {
          maxScrollLeft: 0,
          scrollDistance: 0,
        };

        carousel.querySelectorAll('img').forEach(function (image) {
          image.draggable = false;
        });

        function isSliderViewport() {
          return window.matchMedia('(max-width: 74.999rem)').matches;
        }

        function measureCarousel() {
          var carouselWidth = carousel.clientWidth;
          var card = carousel.querySelector('.signature-pieces__card');
          var scrollDistance = carouselWidth;

          if (card) {
            var styles = window.getComputedStyle(carousel);
            var gap = parseFloat(styles.columnGap) || 0;
            scrollDistance = card.offsetWidth + gap;
          }

          carouselMetrics.maxScrollLeft = Math.max(0, carousel.scrollWidth - carouselWidth);
          carouselMetrics.scrollDistance = scrollDistance;
        }

        function updateControls() {
          var maxScrollLeft = carouselMetrics.maxScrollLeft;
          var currentScrollLeft = carousel.scrollLeft;
          var hasOverflow = isSliderViewport() && maxScrollLeft > 1;
          var controlsShouldBeHidden = !hasOverflow;
          var previousShouldBeDisabled = !hasOverflow || currentScrollLeft <= 1;
          var nextShouldBeDisabled = !hasOverflow || currentScrollLeft >= maxScrollLeft - 1;

          if (controls.hidden !== controlsShouldBeHidden) controls.hidden = controlsShouldBeHidden;
          if (previousButton.disabled !== previousShouldBeDisabled) previousButton.disabled = previousShouldBeDisabled;
          if (nextButton.disabled !== nextShouldBeDisabled) nextButton.disabled = nextShouldBeDisabled;
        }

        function scheduleControlsUpdate() {
          if (updateFrame !== null) return;
          updateFrame = window.requestAnimationFrame(function () {
            updateFrame = null;
            updateControls();
          });
        }

        function scheduleCarouselMeasurement() {
          if (updateFrame !== null) return;
          updateFrame = window.requestAnimationFrame(function () {
            updateFrame = null;
            measureCarousel();
            updateControls();
          });
        }

        function scrollCarousel(direction) {
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          carousel.scrollBy({
            left: carouselMetrics.scrollDistance * direction,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        }

        previousButton.addEventListener('click', function () {
          scrollCarousel(-1);
        });

        nextButton.addEventListener('click', function () {
          scrollCarousel(1);
        });

        carousel.addEventListener('scroll', scheduleControlsUpdate, { passive: true });
        carousel.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });

        // Press-and-drag to scroll (mouse). Uses the same threshold as the PDP
        // "You May Also Like" carousel so a plain click still opens the card.
        var isDown = false;
        var startX = 0;
        var scrollLeft = 0;
        var isDragging = false;
        var THRESHOLD = 5;

        carousel.addEventListener('mousedown', function (event) {
          if (!isSliderViewport()) return;
          if (event.button !== 0) return;
          if (event.target.closest('button, input, select, textarea')) return;

          isDown = true;
          isDragging = false;
          startX = event.pageX - carousel.offsetLeft;
          scrollLeft = carousel.scrollLeft;
        });

        function endDrag() {
          isDown = false;
          carousel.classList.remove('is-dragging');
          scheduleControlsUpdate();
        }
        carousel.addEventListener('mouseleave', endDrag);
        carousel.addEventListener('mouseup', endDrag);

        carousel.addEventListener('mousemove', function (event) {
          if (!isDown) return;

          var x = event.pageX - carousel.offsetLeft;
          if (!isDragging && Math.abs(x - startX) > THRESHOLD) {
            isDragging = true;
            carousel.classList.add('is-dragging');
          }
          if (!isDragging) return;

          event.preventDefault();
          carousel.scrollLeft = scrollLeft - (x - startX) * 1.4;
        });

        // Suppress the click that follows a real drag so links don't navigate.
        carousel.addEventListener(
          'click',
          function (event) {
            if (isDragging) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
          true
        );

        if ('ResizeObserver' in window) {
          var resizeObserver = new ResizeObserver(scheduleCarouselMeasurement);
          resizeObserver.observe(carousel);
        }
        window.addEventListener('resize', scheduleCarouselMeasurement);

        measureCarousel();
        updateControls();
      });
    }

    function init(root) {
      initWishlist(root);
      initHoverGallery(root);
      initCardLinks(root);
      initCarousel(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    // Theme editor: re-wire the card hooks when the section is (re)rendered.
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-evidence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var activeLightbox = null;

    function getPackagingSlides(packaging) {
      return packaging ? packaging.querySelectorAll('.workshop-evidence__package-slide') : [];
    }

    function loadPackageSlideImage(slide) {
      var image = slide ? slide.querySelector('img[data-workshop-image-src]') : null;
      if (!image) return;

      image.src = image.dataset.workshopImageSrc;
      image.removeAttribute('data-workshop-image-src');
    }

    function primeWorkshopVideoFrame(video) {
      if (!video || video.dataset.workshopPreviewPrimed === 'true') return;

      video.dataset.workshopPreviewPrimed = 'true';

      var seekPreviewFrame = function () {
        if (!video.paused || video.readyState === 0) return;

        try {
          if (video.duration > 0.16) {
            video.currentTime = 0.12;
          }
        } catch (error) {
          // Some browsers can reject early media seeks; the play button remains usable.
        }
      };

      if (video.readyState >= 1) {
        seekPreviewFrame();
      } else {
        video.addEventListener('loadedmetadata', seekPreviewFrame, { once: true });
      }
    }

    function loadWorkshopVideo(video) {
      if (!video) return;

      if (video.getAttribute('src')) {
        primeWorkshopVideoFrame(video);
        return;
      }

      video.src = video.dataset.workshopVideoSrc;
      video.removeAttribute('data-workshop-video-src');
      video.load();
      primeWorkshopVideoFrame(video);
    }

    function getSlideImageAlt(slide) {
      var image = slide ? slide.querySelector('img') : null;
      return image ? image.alt : '';
    }

    function setPackageIndex(packaging, index) {
      var slides = getPackagingSlides(packaging);
      if (!slides.length) return;

      var nextIndex = (index + slides.length) % slides.length;
      loadPackageSlideImage(slides[nextIndex]);
      packaging.dataset.workshopPackageIndex = nextIndex;
      packaging.style.setProperty('--workshop-package-index', nextIndex);

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === nextIndex);
      });

      packaging.querySelectorAll('[data-workshop-package-dot]').forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === nextIndex);
      });
    }

    function setLightboxIndex(lightbox, index) {
      var section = lightbox ? lightbox.closest('.workshop-evidence') : null;
      var packaging = section ? section.querySelector('[data-workshop-packaging]') : null;
      var slides = getPackagingSlides(packaging);
      var image = lightbox ? lightbox.querySelector('[data-workshop-lightbox-image]') : null;
      if (!lightbox || !packaging || !slides.length || !image) return;

      var nextIndex = (index + slides.length) % slides.length;
      var nextSlide = slides[nextIndex];
      var nextSrc = nextSlide ? nextSlide.dataset.workshopLightboxSrc : '';
      if (!nextSrc) return;

      setPackageIndex(packaging, nextIndex);
      image.src = nextSrc;
      image.alt = getSlideImageAlt(nextSlide) || image.alt;
      lightbox.dataset.workshopLightboxIndex = nextIndex;
    }

    function openLightbox(section, index) {
      var lightbox = section ? section.querySelector('[data-workshop-lightbox]') : null;
      var image = lightbox ? lightbox.querySelector('[data-workshop-lightbox-image]') : null;
      if (!lightbox || !image) return;

      setLightboxIndex(lightbox, Number(index || 0));
      activeLightbox = lightbox;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('workshop-evidence-lightbox-open');

      var closeButton = lightbox.querySelector('[data-workshop-lightbox-close]');
      if (closeButton) closeButton.focus();
    }

    function closeLightbox(lightbox) {
      if (!lightbox) return;

      var image = lightbox.querySelector('[data-workshop-lightbox-image]');
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('workshop-evidence-lightbox-open');

      if (image) {
        setTimeout(function() {
          if (!lightbox.classList.contains('is-open')) {
            image.removeAttribute('src');
          }
        }, 300);
      }

      if (activeLightbox === lightbox) activeLightbox = null;
    }

    document.addEventListener('click', function (event) {
      var videoFrame = event.target.closest('.workshop-evidence__video-frame');
      if (videoFrame) {
        var card = videoFrame.closest('[data-workshop-video-card]');
        var video = card ? card.querySelector('video') : null;
        if (!video) return;

        loadWorkshopVideo(video);

        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
        return;
      }

      var prevButton = event.target.closest('[data-workshop-package-prev]');
      if (prevButton) {
        var prevPackaging = prevButton.closest('[data-workshop-packaging]');
        var prevIndex = Number(prevPackaging.dataset.workshopPackageIndex || 0);
        setPackageIndex(prevPackaging, prevIndex - 1);
        return;
      }

      var nextButton = event.target.closest('[data-workshop-package-next]');
      if (nextButton) {
        var nextPackaging = nextButton.closest('[data-workshop-packaging]');
        var nextIndex = Number(nextPackaging.dataset.workshopPackageIndex || 0);
        setPackageIndex(nextPackaging, nextIndex + 1);
        return;
      }

      var dotButton = event.target.closest('[data-workshop-package-dot]');
      if (dotButton) {
        var dotPackaging = dotButton.closest('[data-workshop-packaging]');
        setPackageIndex(dotPackaging, Number(dotButton.dataset.workshopPackageIndex || 0));
        return;
      }

      var lightboxPrevButton = event.target.closest('[data-workshop-lightbox-prev]');
      if (lightboxPrevButton) {
        var prevLightbox = lightboxPrevButton.closest('[data-workshop-lightbox]');
        var lightboxPrevIndex = Number(prevLightbox.dataset.workshopLightboxIndex || 0);
        setLightboxIndex(prevLightbox, lightboxPrevIndex - 1);
        return;
      }

      var lightboxNextButton = event.target.closest('[data-workshop-lightbox-next]');
      if (lightboxNextButton) {
        var nextLightbox = lightboxNextButton.closest('[data-workshop-lightbox]');
        var lightboxNextIndex = Number(nextLightbox.dataset.workshopLightboxIndex || 0);
        setLightboxIndex(nextLightbox, lightboxNextIndex + 1);
        return;
      }

      var lightboxButton = event.target.closest('[data-workshop-lightbox-open]');
      if (lightboxButton) {
        var section = lightboxButton.closest('.workshop-evidence');
        openLightbox(section, Number(lightboxButton.dataset.workshopLightboxIndex || 0));
        return;
      }

      var closeButton = event.target.closest('[data-workshop-lightbox-close]');
      if (closeButton) {
        closeLightbox(closeButton.closest('[data-workshop-lightbox]'));
      }
    });

    var touchStartX = 0;
    var touchEndX = 0;
    document.addEventListener('touchstart', function(e) {
      var track = e.target.closest('[data-workshop-package-track]');
      if (track && e.changedTouches && e.changedTouches.length > 0) {
        touchStartX = e.changedTouches[0].screenX;
      }
    }, {passive: true});

    document.addEventListener('touchend', function(e) {
      var packaging = e.target.closest('[data-workshop-packaging]');
      if (packaging && e.changedTouches && e.changedTouches.length > 0) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          var currentIndex = Number(packaging.dataset.workshopPackageIndex || 0);
          if (diff > 0) {
            setPackageIndex(packaging, currentIndex + 1);
          } else {
            setPackageIndex(packaging, currentIndex - 1);
          }
        }
      }
    }, {passive: true});

    document.addEventListener('dragstart', function(e) {
      if (e.target.closest('.workshop-evidence__video') || e.target.closest('.workshop-evidence__package-slide img')) {
        e.preventDefault();
      }
    });

    document.querySelectorAll('.workshop-evidence__media-grid').forEach(function(slider) {
      var isDown = false;
      var startX;
      var scrollLeft;

      slider.addEventListener('mousedown', function(e) {
        // Prevent drag on packaging controls
        if (e.target.closest('.workshop-evidence__package-nav') || e.target.closest('.workshop-evidence__package-dot')) {
          return;
        }
        isDown = true;
        slider.classList.add('is-dragging');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', function() {
        isDown = false;
        slider.classList.remove('is-dragging');
      });
      slider.addEventListener('mouseup', function() {
        isDown = false;
        slider.classList.remove('is-dragging');
      });
      slider.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - slider.offsetLeft;
        var walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!activeLightbox) return;

      if (event.key === 'Escape') {
        closeLightbox(activeLightbox);
      }

      if (event.key === 'ArrowLeft') {
        setLightboxIndex(activeLightbox, Number(activeLightbox.dataset.workshopLightboxIndex || 0) - 1);
      }

      if (event.key === 'ArrowRight') {
        setLightboxIndex(activeLightbox, Number(activeLightbox.dataset.workshopLightboxIndex || 0) + 1);
      }
    });

    document.querySelectorAll('[data-workshop-video-card] video').forEach(function (video) {
      video.addEventListener('play', function () {
        var card = video.closest('[data-workshop-video-card]');
        if (card) card.classList.add('is-playing');
      });

      video.addEventListener('pause', function () {
        var card = video.closest('[data-workshop-video-card]');
        if (card) card.classList.remove('is-playing');
      });
    });

    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          loadWorkshopVideo(entry.target);
          videoObserver.unobserve(entry.target);
        });
      }, { rootMargin: '520px 0px' });

      document.querySelectorAll('.workshop-evidence__video[data-workshop-video-src]').forEach(function (video) {
        videoObserver.observe(video);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
